export const FILE_FORMAT_VERSION = 1;
export const MAX_KNOWN_VERSION = 1;
export const FILE_EXTENSION = ".oesif";
export const FILE_MAGIC_BYTES = "OESF";
export const PBKDF2_ITERATIONS = 600_000;
export const MAX_ITERATIONS = 10_000_000;

/**
 * Minimum acceptable PBKDF2 iteration count on parse.
 *
 * Set well below current OWASP guidance (600,000) to allow forward-compatible
 * tuning if hardware constraints ever require a lower value, but high enough
 * to defeat trivially-cracked files. A file specifying iterations below this
 * value will be rejected on parse, regardless of whether the auth tag validates.
 */
export const MIN_ITERATIONS = 100_000;

/** Header byte layout for format v1. */
export const HEADER_SIZE = 49;
export const OFFSET_MAGIC = 0;       // 4 bytes
export const OFFSET_VERSION = 4;     // 1 byte
export const OFFSET_SALT = 5;        // 16 bytes
export const OFFSET_IV = 21;         // 12 bytes
export const OFFSET_ITERATIONS = 33; // 4 bytes (uint32 BE)
export const OFFSET_TIMESTAMP = 37;  // 8 bytes (int64 BE, Unix seconds)
export const OFFSET_BODY_LEN = 45;   // 4 bytes (uint32 BE)
export const OFFSET_BODY = 49;       // variable
